import React, { useState, useEffect } from 'react';
import { Gallery } from 'react-grid-gallery';
import styles from './Menu.module.css';
import { Link } from 'react-router-dom';
import type { ChangeEvent } from 'react';

import type { Donut, ItemProps } from '../assets/types';

type TGallery = Array<{
  src: string
  width: number
  height: number
  thumbnailCaption: string
  isSelected: boolean
}>;

interface TCart {
  id: number
  name: string
  price: number
}

function Item({
  donut,
  quantity,
  handleCount
}: ItemProps & { handleCount: (event: ChangeEvent<HTMLInputElement>) => void }): JSX.Element {
  return (
    <li
      key={donut.name}
    >
      <form>
        <label htmlFor={donut.name}>{donut.name}</label>
        <input id={donut.name}
          className={styles.item}
          type="number"
          defaultValue={quantity}
          onChange={handleCount}
          min="1"
        />
      </form>
    </li>
  );
}

const callStock = async (): Promise<any> => {
  const response = await fetch('https://soarin-donuts-backend.fly.dev/stocks');
  const data = await response.json();

  if (response.status === 404) {
    throw new Error('Status 404 received');
  }
  return data;
};

interface Stock {
  _id: string
  name: string
  in_stock: boolean
}
let s: Stock[] = [];

// function initStock(): void {
//   s = [];
//   callStock()
//     .then(data => {
//       for (let i = 0; i < data.length; i++) {
//         s.push(data[i]);
//         g = data[i].in_stock === false ? g.filter(({ thumbnailCaption }) => thumbnailCaption !== data[i].name) : g;
//       }
//       console.log(g);
//     })
//     .catch(error => {
//       console.error(error);
//     })
// }
// initStock();
function Menu(): JSX.Element {
  const [t, sett] = useState<TGallery>([]);
  const [donuts, setDonuts] = useState<Donut[]>([]);
  const [cart, setCart] = useState<ItemProps[]>([]);

  const handleCount = (event: ChangeEvent<HTMLInputElement>): void => {
    setCart(cart => {
      const i: number = cart.findIndex(e => e.donut.name === event.target.id);
      cart[i].quantity = event.target.valueAsNumber;
      return cart;
    });
  }

  const fetchMenu = async (): Promise<void> => {
    const response = await fetch('https://soarin-donuts-backend.fly.dev/api/donuts');
    let data: Donut[] = await response.json();

    const responseStock = await fetch('https://soarin-donuts-backend.fly.dev/stocks');
    const dataStock = await responseStock.json();
    s = [];
    for (let i = 0; i < dataStock.length; i++) {
      s.push(dataStock[i]);
    }

    if (response.status === 404) {
      throw new Error('Status 404 received');
    }

    // console.log('s: ', s.length);

    console.log('data', data);

    for (let i = 0; i < s.length; i++) {
      data = !s[i].in_stock ? data.filter(({ name }) => name !== s[i].name) : data;
    }
    setDonuts(data);
    sett(data?.map((donut: Donut) => {
      const picPath: string = (donut?.picture) ?? 'glazed_donut';
      const name: string = (donut?.name) ?? 'glazed donut';
      const price: string = String(donut?.price) ?? '1.99';
      return {
        src: `images/${picPath}.jpg`,
        width: 23,
        height: 23,
        thumbnailCaption: `${name} - $${price}`,
        isSelected: false
      }
    }))
  };

  useEffect(() => {
    void fetchMenu();
  }, [])

  const handleSelect: (index: number) => void = (index: number) => {
    console.log('t', t[index])
    const nextImages = (t).map((image, i) =>
      i === index ? { ...image, isSelected: !image.isSelected } : image
    );
    console.log('nextImages', nextImages[index])

    setCart(cart => {
      // If it already exists in the cart, don't add it
      const tName: string = t[index].thumbnailCaption.split('-')[0].slice(0, -1);
      const curDonut = cart.find(e => e.donut.name === tName);
      if (!t[index].isSelected && curDonut === undefined) {
        cart.push({
          donut: donuts[index],
          quantity: 1
        });
        console.log('cart', cart)
      }
      return t[index].isSelected ? cart.filter(({ donut }) => donut.name !== tName) : cart
    })

    sett(nextImages);
  };

  // setCart(cart => {
  //   for (let i: number = 0; i < t.length; i++) {
  //     t[i].isSelected = cart.some(e => e.donut.name === t[i].thumbnailCaption);
  //     console.log(cart, t[i].isSelected);
  //   }
  //   return cart;
  // })

  // useEffect(() => {
  //   s = [];
  //   callStock()
  //     .then(data => {
  //       for (let i = 0; i < data.length; i++) {
  //         s.push(data[i]);
  //         t = data[i].in_stock === false ? t.filter(({ thumbnailCaption }) => thumbnailCaption !== data[i].name) : t;
  //       }
  //     })
  //     .catch(error => {
  //       console.error(error);
  //     })
  // }, []);

  return (
    <div className={styles.container}>
      <div className={styles.cart}>
        <div>
          <p className={styles.header}>Cart</p>
          <div className={styles.cart2}>
            <ul role="list">
              {cart.map((item) =>
                <Item
                  handleCount={handleCount}
                  {...item}
                />
              )}
            </ul>
          </div>
          {cart.length > 0 && <Link className={styles.placeorder} to={{ pathname: '/checkout' }} state={{ data: cart }}>Place Order</Link>}
        </div>
      </div>
      <div className={styles.gallery1}>
        <h1 className={styles.header}>Soarin Donuts</h1>
        <div className={styles.gallery2}>
          <Gallery images={t} onSelect={handleSelect} />
        </div>
      </div>
    </div>
  );
}

export default Menu;
